import { useState } from 'react';
import { useReduxStore } from './useReduxStore';

export const useEmailVerification = () => {
  const { getState, dispatch } = useReduxStore();
  const [isVerifying, setIsVerifying] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState('unverified'); // 'verified', 'unverified', 'pending'

  const { userData } = getState("AUTH");
  const { isVerified } = userData || {};

  // Check if email is verified based on user data
  const isEmailVerified = isVerified || false;

  const sendVerificationEmail = async () => {
    setIsVerifying(true);
    try {
      // This function is now handled in BasicInfoComponent
      // This hook is kept for backward compatibility
      console.log('Sending verification email to:', userData?.email);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Update verification status
      setVerificationStatus('pending');
      
    } catch (error) {
      console.error('Error sending verification email:', error);
    } finally {
      setIsVerifying(false);
    }
  };

  return {
    isEmailVerified,
    isVerifying,
    verificationStatus,
    sendVerificationEmail
  };
};
